import React from 'react';

import { messages } from './messages';
import { TextSection } from '../../../tab-section/text-section/text-section';

export const Cancelled = () => {
  return (
    <TextSection
      ariaLabelMessageDescriptor={messages.cancelledSectionAriaLabel}
      contentMessageDescriptor={messages.cancelledSectionContent}
      headerMessageDescriptor={messages.cancelledSectionHeader}
    />
  );
};
